// extracted by mini-css-extract-plugin
export default {"table":"table_table__IdyxO","title":"table_title__70s5n","tableHeader":"table_tableHeader__VNG0o","tableData":"table_tableData__MAv+Z","borderStyle":"table_borderStyle__MHThR"};